/**
 * Determine if the user has the ability to reauthenticate.
 *
 * This indicates whether the user has the ability to perform a reauthentication
 * to prove they own the account. This can be either a password or a single-sign
 * on method.
 *
 * @param hasPassword Does the user have a password?
 * @param appleId The apple ID for the user, if they have one.
 * @param facebookId The facebook ID for the user, if they have one.
 * @param googlePrimaryEmail The primary email used for Google login, if the
 * user has one.
 * @param microsoftId The microsoft ID for the user, if they have one.
 * @returns `true` if the user can reauthenticate; otherwise, `false`.
 */
export const userCanReauth = (
    hasPassword: boolean,
    appleId: Nullable<string>,
    facebookId: Nullable<string>,
    googlePrimaryEmail: Nullable<string>,
    microsoftId: Nullable<string>,
): boolean => {
    return (
        hasPassword ||
        !!appleId ||
        !!facebookId ||
        !!googlePrimaryEmail ||
        !!microsoftId
    );
};
